// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ra-t","col":"styles_col__1pUuy","actions":"styles_actions__2EGK0","conflict":"styles_conflict__37CUo"};